import { render, staticRenderFns } from "./header-language-selector.vue?vue&type=template&id=4a79d002&"
import script from "./header-language-selector.vue?vue&type=script&lang=ts&"
export * from "./header-language-selector.vue?vue&type=script&lang=ts&"
import style0 from "./header-language-selector.vue?vue&type=style&index=0&lang=scss&_scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports